function toggleSelection<T>(currentList: T[] | undefined, item: T): T[] {
  const currentItemList: T[] = currentList || [];
  const isItemAlreadySelected: boolean = currentItemList.includes(item);

  if (isItemAlreadySelected) {
    return currentItemList.filter((currentItem: T) => currentItem !== item);
  } else {
    return [...currentItemList, item];
  }
}

export { toggleSelection };
